import React, { Component } from "react";
import { connect } from "react-redux";
import { FilePond } from "react-filepond";
import { withRouter } from "react-router-dom";
import "filepond/dist/filepond.min.css";

// Service Import
import { uploadPDF } from "../../actions/DocumentActions/index";

// Internal Imports
import { GlobalUtils } from "../../utils";
import { PATHS, DOCUMENTS, IMAGE_URLS } from "../../constants";
import { customGAEvent } from "../../gtm/gtmutils";
import { GTM_CUSTOM_EVENTS, GTM_EVENT_PARAMS } from "../../gtm/gtmcustomevents";
import { API_ERRORS } from "../../constants/errorMsg";
import LZLoader from "../../commonComponents/LZLoader";

const { DOCUMENT_MODE } = DOCUMENTS;

// Destructuring
const { writeDataToLocalStorage } = GlobalUtils;
const { UPLOAD_FORMAT_IMG } = IMAGE_URLS;

class QuotationUpload extends Component {
  state = {
    fileDetails: { name: null, size: 0 },
  };

  constructor(props) {
    super(props);
    this.filePond = React.createRef();
  }

  _uploadPDF = data => {
    const fileItems = this.filePond.current.getFiles();
    const mode =
      this.props.page === "DOCUMENT"
        ? DOCUMENT_MODE.DOCUMENT
        : DOCUMENT_MODE.TEMPLATE;

    const payload = {
      data,
      folderId: this.props.currentFolderID || null,
    };
    uploadPDF(mode)(payload)
      .then(res => {
        const params = {};
        params[GTM_EVENT_PARAMS.UPLOAD_TYPE] = fileItems[0].fileExtension;
        params[GTM_EVENT_PARAMS.FILE_NAME] = data.name;
        customGAEvent(GTM_CUSTOM_EVENTS.DOC_UPLOADED, params);
        writeDataToLocalStorage("documentPageSource", "assets");
        const path =
          mode === DOCUMENT_MODE.DOCUMENT
            ? `${PATHS.DOCUMENTS_PATH}/${res}`
            : `${PATHS.DOCSTEMPLATE_PATH}/${res}`;
        this.props.history.push(path);
      })
      .catch(err => {
        let errorMessage =
          "File is too large. Upload PDF or docx less than 15 MB. Ping us on chat for help.";
        if (err && err.response && err.response.data) {
          errorMessage = API_ERRORS[err.response.data.code] || errorMessage;
        }
        this.props.setDoc({
          error: errorMessage,
        });
        console.error(`QuotationUpload => _uploadPDF => ${err}`);
      });
  };

  updateFile = fileItems => {
    // const fromDocPage = this.props.page === "DOCUMENT";
    fileItems = this.filePond.current.getFiles();
    if (Object.keys(fileItems).length !== 0) {
      if (fileItems[0].fileExtension === "pdf") {
        this._uploadPDF(fileItems[0].file);
      } else if (fileItems[0].fileExtension === "docx") {
        if (
          !(
            fileItems[0].filename === this.state.fileDetails.name &&
            fileItems[0].fileSize === this.state.fileDetails.size
          )
        ) {
          const fileDetails = fileItems[0].file;
          this.props.setDoc({ fileDetails });
        } else {
          const fileDetails = { name: null, size: 0 };
          this.props.setDoc({ fileDetails });
        }
      } else {
        this.props.setDoc({
          error: "Only PDF and docx files are supported.",
        });
      }
    }
  };

  _progressIndicator = () => {
    const { uploaded } = this.props;
    if (uploaded === false) {
      return <LZLoader className="file-uploading" label="Uploading..." />;
    }
    return null;
  };

  render() {
    const fromDocPage = this.props.page === "DOCUMENT";
    const label = fromDocPage
      ? `<img src=${UPLOAD_FORMAT_IMG}></img><div> Drag and drop or upload a PDF or a .docx file here</div>`
      : "Drag & drop a .docx file or a .pdf file or <u>browse</u> to upload";
    return (
      <div className={fromDocPage ? "quotationupload-doc" : ""}>
        <FilePond
          allowMultiple={false}
          ref={this.filePond}
          labelIdle={label}
          onaddfile={() => this.updateFile()}
        />
      </div>
    );
  }
}
const mapStateToProps = ({ AssetStore: { currentFolderID } }) => ({
  currentFolderID,
});
export default connect(mapStateToProps)(withRouter(QuotationUpload));
